@if (infoMessage$ | async; as infoMessage) {
  @if (infoMessage?.showMessage) {
    <section class="mb-16">
      <stb-alert
        [surfaceVariant]="'surface-1'"
        [rebrand]="true"
        [heading]="infoMessage?.heading"
        width="fluid"
        [type]="infoMessage?.type"
      >
        <div [innerHTML]="infoMessage?.innerHTML"></div>
      </stb-alert>
    </section>
  }
}
